import { render } from "./SearchForm.vue?vue&type=template&id=da22a810&scoped=true&ts=true"
import script from "./SearchForm.vue?vue&type=script&lang=ts"
export * from "./SearchForm.vue?vue&type=script&lang=ts"

import "./SearchForm.vue?vue&type=style&index=0&id=da22a810&scoped=true&lang=css"

import exportComponent from "/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-da22a810"]])

export default __exports__